import { Observation, Patient, Reference } from "@medplum/fhirtypes";

import { getCodeableConceptCode } from "@/utils/medplum";

export type ObservationStatus = Observation["status"];

/**
 * Find the Observation carrying a given code, in any coding system.
 *
 * Panel members arrive in no guaranteed order, so an Observation is located by its code rather
 * than by position. Both the prenatal flowsheet table and the client export resolve their members
 * through this one function, so the printed record and the screen cannot disagree about which
 * Observation is which.
 *
 * Matches on code alone. Where a caller must also pin the coding system, such as the physical-exam
 * and vitals extractors, that comparison stays with the caller.
 *
 * @param observations the Observations to search, typically one panel's resolved `hasMember` list
 * @param code the code to match, usually a `LOINCCodes` member
 */
export function findObservationByCode(
  observations: Observation[] | undefined,
  code: string,
): Observation | undefined {
  return observations?.find((observation) => getCodeableConceptCode(observation?.code) === code);
}

export type CommonObservationProps = {
  id?: string;
  status: ObservationStatus;
  subject: Reference<Patient>;
  effectiveDateTime: Date;
};

export type IntegerObservationProps = CommonObservationProps & {
  valueInteger: number;
};

export type DateTimeObservationProps = CommonObservationProps & {
  valueDateTime: Date;
};
